/* eslint-disable */
// import tooltip from "@/echarts/echartTooltip";
import router from '@/router'
import store from '@/store'
function sort(key, type, data) {
  let sortData = JSON.parse(JSON.stringify(data))
  if (key !== '') {
    sortData = sortData.sort(function (a, b) {
      if (type === 'desc') {
        return a[key] - b[key]
      } else {
        return b[key] - a[key]
      }
    })
  } else {
    sortData = sortData.sort(function (a, b) {
      if (type === 'desc') {
        return a - b
      } else {
        return b - a
      }
    })
  }
  return sortData
}
function checkUnit(data) {
  data = Math.abs(data)
  if (data > 10000000) {
    return 100000000
  } else if (data > 1000) {
    return 10000
  } else {
    return 1
  }
}
function formatRoundNum(num){
  let integer = Math.ceil(num)
  let length = String(integer).length
  return Math.ceil(integer/Math.pow(10, length-1))*Math.pow(10, length-1)
}

const unitText = {
  10000: '万',
  100000000: '亿',
  1: ''
}

export default function chartOptions(option, data, dataType) {
  const { type, animation, json, zoom, rate, title, show, legend, graphicValue, graphicLabel, showLegend, isTrend, showVisual, hideVisualMap, max, min, stack } = data
  const colorType = router.history.current.query.type
  switch (type) {
    case 'pic': //饼图
      let pieChartData = option.series
      if (pieChartData.length < 1) {
        return {}
      }
      let labelPieData = JSON.parse(JSON.stringify(pieChartData))
      labelPieData.forEach(item => {
        // if (item.value < 5) {
        //   item.label = {
        //     show: false
        //   };
        // }
      })
      let pieFinalSeries = [
        {
          // name: pieChartData,
          type: 'pie',
          radius: '70%',
          top: 20,
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = []
                if (pieChartData.length < 4) {
                  colorList = ['#fdc12d', '#fc5c2c', '#30c9f2']
                } else {
                  colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          label: {
            show: false,
            formatter: function (params) {
              return params.percent < 4 ? '' : params.percent + '%'
            },
            color: store.getters.themeType === 'dark' ? '#fff' : '#000',
            position: 'inside',
            lineHeight: 90
          },
          data: labelPieData
        },
        {
          // name: pieChartData,
          type: 'pie',
          radius: '70%',
          top: 20,
          label: {
            show: true,
            position: 'outer',
            alignTo: 'labelLine',
            lineHeight: 30,
            color: store.getters.themeType === 'dark' ? '#969797' : '#000',
            formatter: '{b}：{a|{d}%}',
            rich: {
              a: {
                color: store.getters.themeType === 'dark' ? '#fff' : '#000'
              }
            }
          },
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = []
                if (pieChartData.length < 4) {
                  colorList = ['#fdc12d', '#fc5c2c', '#30c9f2']
                } else {
                  colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          labelLine: {
            lineStyle: {
              color: colorType === 'black' ? '#969797' : '#000'
            }
          },
          data: pieChartData
        }
      ]
      let pie = {
        animation: animation !== undefined ? animation : true,
        tooltip: {
          show: true
          // formatter: function(){
          //   return 'value'
          // }
        },
        grid: {
          top: 40,
          bottom: 30
        },
        legend: {
          show: showLegend ? true : legend === 'horizontal' ? false : true,
          orient: legend === 'horizontal' ? 'horizontal' : 'vertical',
          right: 10,
          left: legend === 'horizontal' ? 0 : 'auto',
          icon: 'circle',
          formatter: function (value) {

            // return value.length > 10 ? value.slice(0, 10) + "..." : value;
            return value
          }
        },
        series: pieFinalSeries
      }
      return pie
    case 'line':
      let line = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: true,
          // padding:-3,
          bottom: -6,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 2,
          textStyle: {
            color: '#B4BAC6',
            fontSize: 10
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        grid: {

          containLabel: true,
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        toolbox: {
          show: true
        },
        xAxis: option.xAxis.map(item => {
          return {
            show: true,
            type: 'category',
            data: item.data,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d8dee6'
              }
            },
            axisLabel: {
              interval: "auto",
              // interval:2,
              rotate: option.series[0] && option.series[0].data.length > 5 ? 20 : 0
            }
          }
        }),
        yAxis: [
          {
            show: true,
            type: 'value',
            axisLine: {
              show: false
            },
            splitLine: {
              //网格线
              lineStyle: {
                type: 'solid',
                color: '#d8dee6'
              },
              show: true //隐藏或显示
            },
            axisTick: {
              show: false
            }
          }
        ],
        grid: {
          // left: 'center',
          top: 20,
          right: 20,
          // bottom: 40,
          // width: '100%',
          containLable: true
        },
        series: option.series.map(item => {
          item.smooth = isTrend ? true : false
          item.symbol = 'circle'
          item.symbolSize = 2
          return item
        })
      }
      Object.assign(line.tooltip, option.tooltip)
      return option.series.length > 0 ? line : {}
    case 'lineto':
      let lineto = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: true,
          // padding:-3,
          bottom: -5,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 4,
          textStyle: {
            color: '#1A173B',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        grid: {
          y: "10%",
          height: "60%"
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        toolbox: {
          show: true
        },
        xAxis: option.xAxis.map(item => {
          return {
            show: true,
            type: 'category',
            data: item.data,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d8dee6'
              }
            },
            axisLabel: {
              interval: "auto",
              // interval:2,
              rotate: option.series[0] && option.series[0].data.length > 5 ? 20 : 0
            }
          }
        }),
        yAxis: [
          {
            show: true,
            type: 'log',
            min: 1000,
            axisLine: {
              show: false
            },
            // minInterval:100,
            splitLine: {
              //网格线
              lineStyle: {
                type: 'solid',
                color: '#d8dee6'
              },
              show: true //隐藏或显示
            },
            axisTick: {
              show: false
            }
          }
        ],
        // grid: {
        //   // left: 'center',
        //   top: 20,
        //   right: 20,
        //   // bottom: 40,
        //   // width: '100%',
        //   containLable: true
        // },
        series: option.series.map(item => {
          item.smooth = isTrend ? true : false
          item.symbol = 'circle'
          item.symbolSize = 2
          return item
        })
      }
      Object.assign(lineto.tooltip, option.tooltip)
      return option.series.length > 0 ? lineto : {}
    case 'line1':
      let line1 = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: true,
          // padding:-3,
          bottom: -5,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 4,
          textStyle: {
            color: '#1A173B',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        toolbox: {
          show: true
        },
        xAxis: option.xAxis.map(item => {
          return {
            show: true,
            type: 'category',
            data: item.data,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d8dee6'
              }
            },
            axisLabel: {
              interval: "auto",
              // interval:2,
              rotate: option.series[0] && option.series[0].data.length > 5 ? 20 : 0
            }
          }
        }),
        yAxis: [
          {
            show: true,
            type: 'value',
            axisLine: {
              show: false
            },
            splitLine: {
              //网格线
              lineStyle: {
                type: 'solid',
                color: '#d8dee6'
              },
              show: true //隐藏或显示
            },
            axisTick: {
              show: false
            }
          }
        ],
        grid: {
          top: 20,
          right: 20,
          height: "65%",
          containLable: true
        },
        series: option.series.map(item => {
          item.smooth = isTrend ? true : false
          item.symbol = 'circle'
          item.symbolSize = 2
          return item
        })
      }
      Object.assign(line1.tooltip, option.tooltip)
      return option.series.length > 0 ? line1 : {}
    case 'block_line':
      let blockLine = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: dataType === 1 ? false : true ,
          // type: "plain",
          bottom: -5,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 4,
          textStyle: {
            // color: '#B4BAC6',
            color: '#1A173B',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        grid: {
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          }
        },
        xAxis: option.xAxis.map(item => {
          return {
            show: true,
            type: 'category',
            data: item.data,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#d8dee6'
              }
            },
            axisLabel: {
              interval: "auto",
              rotate: option.series[0] && option.series[0].data.length > 5 ? 20 : 0
            }
          }
        }),
        yAxis: option.yAxis.map((item, i) => {
          return {
            show: true,
            type: 'value',
            axisLine: {
              show: false
            },
            max: max?max:null,
            splitLine: {
              //网格线
              lineStyle: {
                type: 'solid',
                color: '#d8dee6'
              },
              show: i === 0 ? true : false //隐藏或显示
            },
            axisTick: {
              show: false
            }
          }
        }),
        grid: {
          left: '3%',
          right: '4%',
          // bottom: 40,
          height: "65%",// 高度
          containLabel: true
        },
        color: ['rgba(234, 85, 25, 1)', 'rgba(121, 157, 206, 1)', 'rgba(252, 200, 0, 1)', 'rgba(121, 157, 206, 1)', 'rgba(209, 134, 181, 1)', 'rgba(222, 222, 222, 1)'],
        series: option.series.map((item, index) => {
          item.smooth = isTrend ? true : false
          item.symbol = 'circle'
          item.areaStyle = {}
          // item.stack = '总量'
          if (stack) {
            item.stack = '总量'
          }
          item.areaStyle = {
            opacity: 0.05
          }
          return item
        })
      }
      return option.series.length > 0 ? blockLine : {}
    case 'ring':
      let ringChart = {
        animation: animation !== undefined ? animation : true,
        legend: {
          type: 'scroll',
          show: dataType === 6 ? false : true ,
          bottom: 0,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 14,
          itemHeight: 4,
          textStyle: {
            color: '#B4BAC6',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        tooltip: {
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: option.series.map(item => {
          return {
            name: item.name,
            type: 'pie',
            radius: ['43%', '59%'],
            bottom: 20,
            top: 10,
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 1
            },
            label: {
              show: true,
              formatter: '{b}：{d}%'
              // color: '#666666'
            },
            data: item.data
          }
        })
      }
      return option.series.length > 0 ? ringChart : {}
      case 'ringtwo':
      let ringChartwo = {
        animation: animation !== undefined ? animation : true,
        // legend: {
        //   icon: "circle",
        //   left: 'right',
        //   orient: 'right',
        //   formatter: val => {
        //     return val.length > 6 ? val.slice(0, 6) + '...' : val
        //   }
        // },
        title: {
          text: option.title.text,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 13,
          },
        },
        tooltip: {
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        series: option.series.map(item => {
          return {
            name: item.name,
            type: 'pie',
            radius: ['43%', '59%'],
            bottom: 20,
            minAngle:10,
            avoidLabelOverlap:true,
            top: 10,
            itemStyle: {
              borderColor: '#ffffff',
              borderWidth: 1
            },
            label: {
              show: true,
              formatter: '{b}：{d}%'
              // color: '#666666'
            },
            data: item.data
          }
        })
      }
      return option.series.length > 0 ? ringChartwo : {}
    case 'treemap':
      let treeBlock = {
        animation: animation !== undefined ? animation : true,
        tooltip: {
          show: true,
          formatter: function (params) {
            if (params.name) {
              if (params.value.length > 0) {
                if (dataType == 2) {
                  return `${params.name}\n\n${params.data.value[2]}%`
                } else if (dataType == 'chinaperson') {
                  return `${params.name}\n\n${params.data.value[1]}`
                }else {
                  return `${params.name}\n\n${params.data.value[2]}`
                }
              } else {
                if(dataType == 1){
                  return `${params.name}\n\n${params.value}`
                }else{
                return `${params.name}\n\n${params.value}%`
                }
              }
            }

          },
        },
        legend: {
        },
        // color:['#ff5d16','#799dce','#fcc800','#f6ab00','#a389e0','#8c8ced'],
        // color:['green','red','yellow','#f6ab00','#a389e0','#8c8ced'],
        series: [
          {
            type: 'treemap',
            // visibleMin: 300,
            label: {
              show: true,
              overflow: "none",
              // formatter: dateType== 2? '{name|{b}}\n\n{percent|{c[2]}%}' : '{name|{b}}\n\n{percent|{c[2]}}',
              formatter: (params) => {
                if (params.name) {
                  if (params.value.length > 0) {
                    if (dataType == 2) {
                      return `${params.name}\n\n${params.data.value[2]}%`
                    } else if (dataType == 'chinaperson') {
                      let value = params.data.value[1]
                      if(localStorage.getItem("language")=='en') {
                        value = this.$util.formatterTreemapEn(value)
                      } else {
                        value = this.$util.formatterTreemap(value)
                      }
                      return `${params.name}\n\n${value}`
                    } else {
                      let value = params.data.value[2]
                      if(localStorage.getItem("language")=='en') {
                        value = this.$util.formatterTreemapEn(value)
                      } else {
                        value = this.$util.formatterTreemap(value)
                      }
                      return `${params.name}\n\n${value}`
                    }
                  } else {
                    if(dataType == 1){
                      return `${params.name}\n\n${params.value}`
                    }else{
                      return `${params.name}\n\n${params.value}%`
                    }
                    
                  }
                }
              },
              rich: {
                name: {
                  fontSize: 14,
                  color: '#ffffff'
                },
                percent: {
                  color: '#ffffff',
                  align: 'right'
                }
              }
            },
            labelLayout(params) {
              // 根据节点的宽度和高度来决定是否显示标签
              let parentWidth = params.rect.width;
              let parentHeight = params.rect.height;
              let labelWidth = params.labelRect.width+4
              let labelHeight = params.labelRect.height
              // 如果节点宽度或高度小于区域的宽度和高度，则隐藏标签
              let isLabelVisible = labelWidth<=parentWidth && labelHeight<=parentHeight
              return {
                fontSize: isLabelVisible? 12: 0,
              }
            },
            // textStyle:{

            // },
            breadcrumb: {
              show: false
            },
            itemStyle: {
              borderColor: '#fff'
            },
            nodeClick: 'zoomToNode',
            levels: [
              {
                itemStyle: {
                  borderWidth: 12,
                  gapWidth: 4
                }
              },
              {
                itemStyle: {
                  gapWidth: 1
                }
              },
              {
                colorSaturation: [0.35, 0.5],
                itemStyle: {
                  gapWidth: 4,
                  borderColorSaturation: 0.7
                }
              }
            ],
            // silent: true,
            // roam: 'move',
            roam: true,
            top: 0,
            left: 0,
            right: 0,
            // bottom: showVisual ? 40 : 20,
            width: '100%',
            height: '95%',
            bottom: 0,
            data: option
          }
        ],
      }

      if (showVisual) {
        treeBlock.visualMap = {
          type: 'continuous',
          orient: 'horizontal',
          // text: ['高', '低'],
          min: min < max ? min : 0,
          max: max,
          calculable: true,
          showLabel: true,
          inRange: {
            color: ['#e75e27', '#dce4fc', '#0a84cb']
          },
          textStyle: {
            color: '#7B93A7'
          },
          itemHeight: 200,
          itemWidth: 10,
          bottom: -10,
          left: 'center',
          right: 0

        }
      }
      return treeBlock
    case 'treemapchina':
      let treeBlockChina = {
        animation: animation !== undefined ? animation : true,
        title: {
          text: option.title.text,
          textStyle: {
            fontSize: 13,
          },
          x: 'center',
          y: 'bottom',

        },
        // grid: {
        //   left: '10%',
        //   right: '1%',
        //   bottom: '7%',

        //       top: '25%',

        //       containLabel: true
        // },
        tooltip: {
          show: true,
          formatter: function (params) {
            if (params.name) {
              if (params.value.length > 0) {
                if (dataType == 2) {
                  return `${params.name}\n\n${params.data.value[2]}%`
                } else {
                  return `${params.name}\n\n${params.data.value[2]}`
                }
              } else {
                return `${params.name}\n\n${params.value}%`
              }
            }

          },
        },
        legend: {
        },
        series: [
          {
            type: 'treemap',
            roam: false,
            // visibleMin: 300,
            // radius:'65%',
            // center: ['50%', '50%'],
            label: {
              show: true,
              formatter: function (params) {
                if (params.name) {
                  if (params.value.length > 0) {
                    if (dataType == 2) {
                      return `${params.name}\n\n${params.data.value[2]}`
                    } else {
                      return `${params.name}\n\n${params.data.value[2]}`
                    }
                  } else {
                    return `${params.name}\n\n${params.value}`
                  }
                }
              },
              rich: {
                name: {
                  fontSize: 14,
                  color: '#ffffff'
                },
                percent: {
                  color: '#ffffff',
                  align: 'right'
                }
              }
            },
            // textStyle:{

            // },
            breadcrumb: {
              show: false
            },
            itemStyle: {
              borderColor: '#fff'
            },
            nodeClick: 'zoomToNode',
            levels: [
              {
                itemStyle: {
                  borderWidth: 12,
                  gapWidth: 4
                }
              },
              {
                itemStyle: {
                  gapWidth: 1
                }
              },
              {
                colorSaturation: [0.35, 0.5],
                itemStyle: {
                  gapWidth: 4,
                  borderColorSaturation: 0.7
                }
              }
            ],
            silent: true,
            top: 0,
            left: 0,
            right: 0,
            // bottom: showVisual ? 40 : 20,
            // width: '100%',
            // height: '95%',
            bottom: 40,
            data: option.data
          }
        ],
      }

      if (showVisual) {
        treeBlockChina.visualMap = {
          type: 'continuous',
          orient: 'horizontal',
          // text: ['高', '低'],
          min: min < max ? min : 0,
          max: max,
          calculable: true,
          showLabel: true,
          inRange: {
            color: ['#e75e27', '#dce4fc', '#0a84cb']
          },
          textStyle: {
            color: '#7B93A7'
          },

          itemHeight: 200,
          itemWidth: 10,
          bottom: -10,
          left: 'center',
          right: 0

        }
      }
      return treeBlockChina
    case 'worldmap':
      let worldmap = {
        animation: animation !== undefined ? animation : true,
        tooltip: {
          show: true,
          trigger: 'item'
        },
        series: [
          {
            type: 'map',
            map: 'world',
            roam: true,
            top: 20,
            scaleLimit: {
              min: 1,
              max: 1
            },
            emphasis: {
              itemStyle: {
                areaColor: 'rgba(252, 200, 0, 1)'
              },
              label: {
                show: false,
                formatter: params => {
                  return params.data ? params.data.cn : ''
                }
              }
            },
            tooltip: {
              // show
              formatter: params => {
                return params.data ? `${params.data.cn}：${params.value}` : ``
              }
            },
            data: option.data
          }
        ]
      }
      if(data.customerLized) {
        worldmap.series[0].top = 'middle'
        worldmap.series[0].left = 10
        worldmap.series[0].right = 10
      }
      if (showVisual) {
        worldmap.visualMap = {
          type: 'continuous',
          orient: 'horizontal',
          show: !hideVisualMap,
          // text: ['高', '低'],
          min: option.min < option.max ? option.min : 0,
          max: option.max,
          calculable: true,
          showLabel: true,
          inRange: {
            // color: ['#edfbfb', '#b7d6f3', '#40a9ed', '#3598c1', '#215096']
            color: ['rgba(227, 240, 255, 1)', 'rgba(161, 205, 255, 1)', 'rgba(94, 169, 255, 1)', 'rgba(53, 147, 255, 1)', 'rgba(0, 119, 255, 1)']
          },
          textStyle: {
            color: '#7B93A7'
          },
          itemHeight: 200,
          itemWidth: 10,
          bottom: 5,
          left: 'center',
          right: 0
        }
      }
      return worldmap
    case 'doughnut': //圆环图 
      let chartData = option.series
      if (chartData.length < 1) {
        return {}
      }
      let labelRingData = JSON.parse(JSON.stringify(chartData))
      // labelRingData.forEach(item => {
      //   if (item.value < 5) {
      //     item.label = {
      //       show: false
      //     };
      //   }
      // });
      let sortData = sort('value', 'asc', option.series)
      let finalSeries = [
        {
          // name: chartData.name,
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = []
                if (chartData.length < 4) {
                  colorList = ['#fdc12d', '#fc5c2c', '#30c9f2']
                } else {
                  colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          label: {
            normal: {
              show: true,
              color: store.getters.themeType === 'dark' ? '#fff' : '#000',
              formatter: '{d}%',
              position: 'inside'
            }
          },
          data: labelRingData
        }
        // {
        //   // name: chartData.name,
        //   type: "pie",
        //   avoidLabelOverlap: true,
        //   itemStyle: {
        //     normal: {
        //       color: function(params) {
        //         let colorList = []
        //         if(chartData.length < 4){
        //           colorList = [
        //             "#fdc12d",
        //             "#fc5c2c",
        //             "#30c9f2",
        //           ];
        //         } else {
        //           colorList = [
        //             "#fdc12d",
        //             "#fe7e23",
        //             "#fc5c2c",
        //             "#30c9f2",
        //             "#25b1e4",
        //             "#2097d1",
        //             "#b5d23c",
        //             "#8dc54a",
        //             "#68ae4b",
        //             "#8e8e8e"
        //           ];
        //         }
        //         return colorList[params.dataIndex % colorList.length];
        //       }
        //     }
        //   },
        //   label: {
        //     color: "#000",
        //     alignTo: "labelLine",
        //     formatter: "{b}"
        //   },
        //   labelLine: {
        //     lineStyle: {
        //       color: "#000"
        //     }
        //   },
        //   radius: ["50%", "70%"],
        //   data: chartData
        // }
      ]
      let ring = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: true,
          // orient: "",
          // right: 10,
          icon: 'circle'
        },
        tooltip: {
          show: true
        },
        series: finalSeries
      }
      return ring
    case 'pic-c':
      let picCData = option.series
      if (picCData.length < 1) {
        return {}
      }
      let labelPicCData = JSON.parse(JSON.stringify(picCData))
      labelPicCData.forEach(item => {
        // if (item.value < 5) {
        //   item.label = {
        //     show: false
        //   };
        // }
      })
      let picCSortData = sort('value', 'asc', option.series)
      let finalPicCSeries = [
        {
          // name: picCData.name,
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = []
                if (picCData.length < 4) {
                  colorList = ['#fdc12d', '#fc5c2c', '#30c9f2']
                } else {
                  colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          label: {
            normal: {
              show: true,
              color: '#000',
              formatter: function (params) {
                return params.percent < 0.5 ? '' : params.percent + '%'
              },
              position: 'inside'
            }
          },
          data: labelPicCData
        },
        {
          // name: picCData.name,
          type: 'pie',
          avoidLabelOverlap: true,
          itemStyle: {
            normal: {
              color: function (params) {
                let colorList = []
                if (picCData.length < 4) {
                  colorList = ['#fdc12d', '#fc5c2c', '#30c9f2']
                } else {
                  colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                }
                return colorList[params.dataIndex % colorList.length]
              }
            }
          },
          label: {
            color: colorType === 'black' ? '#969797' : '#000',
            // alignTo: "edge",
            formatter: '{b}'
          },
          labelLine: {
            lineStyle: {
              color: colorType === 'black' ? '#969797' : '#000'
            }
          },
          radius: ['50%', '70%'],
          data: picCData
        }
      ]
      let picC = {
        legend: {
          show: true,
          orient: 'horizontal',
          left: 0,
          icon: 'circle'
        },
        graphic: {
          //图形中间文字
          type: 'group',
          left: 'center',
          top: 'center',
          children: [
            {
              type: 'text',
              style: {
                text: graphicValue,
                textAlign: 'center',
                fill: colorType === 'black' ? '#fff' : '#000',
                fontSize: 16,
                y: -20
              }
            },
            {
              type: 'text',
              style: {
                text: graphicLabel,
                textAlign: 'center',
                fill: colorType === 'black' ? '#fff' : '#000',
                fontSize: 16,
                y: 20
              }
            }
          ]
        },
        series: finalPicCSeries
      }
      return picC
    case 'bar1': //柱状图
      let barChartData = option.series
      let barlegend = {}
      let barGrid = {}
      if (barChartData.length > 1) {
        //对比
        barGrid.right = 40
        barGrid.left = 50
        let bData = []
        barChartData.forEach(b => {
          bData = bData.concat(b.data)
        })
        let sortBarData = sort('', 'desc', bData)
        let unit = unitText[checkUnit(sortBarData[0] === 0 || sortBarData[0] < 100 ? sortBarData[1] : sortBarData[0])]
        let returnData = []
        barChartData.forEach(b => {
          let bData = b.data.map(d => {
            return (d / checkUnit(sortBarData[0] === 0 || sortBarData[0] < 100 ? sortBarData[1] : sortBarData[0])).toFixed(2)
          })
          b.data = bData
          returnData.push(b)
        })
        if (title.indexOf('占比') > -1 || title.indexOf('增长率') > -1) {
          unit = '%'
        }
        barChartData = returnData
        barlegend = {
          show: true,
          top: 20,
          // orient: 'vertical',
          // right: 10,
          icon: 'circle'
        }
        barChartData.forEach(item => {
          item.label = {
            show: true,
            position: 'top',
            color: colorType === 'black' ? '#fff' : '#000',
            fontSize: 10,
            formatter: `{c}${unit}`
          }
          item.barMaxWidth = 50
        })
      } else {
        //单柱状图
        barGrid.right = 40
        barGrid.top = 20
        barlegend = {
          show: false
        }
        let sortBarData = sort(
          '',
          'desc',
          barChartData[0].data.filter(item => item !== 0 || item > 100)
        )
        let unit = unitText[checkUnit(sortBarData[0] === 0 || sortBarData[0] < 100 ? sortBarData[1] : sortBarData[0])]
        let returnData = barChartData[0].data.map(item => {
          return (item / checkUnit(sortBarData[0] === 0 || sortBarData[0] < 100 ? sortBarData[1] : sortBarData[0])).toFixed(2)
        })
        if (title.indexOf('占比') > -1 || title.indexOf('增长率') > -1) {
          unit = '%'
        }
        barChartData[0] = {
          type: 'bar',
          barMaxWidth: 25,
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                return colorList[params.dataIndex % colorList.length]

              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'top',
              color: colorType === 'black' ? '#fff' : '#000',
              fontSize: 10,
              formatter: `{c}${unit}`
            }
          },
          data: returnData
        }
      }
      if (barChartData[0].data.length > 20 || barChartData[0].data.length > 10) {
        barGrid.bottom = 100
      }
      let bar = {
        legend: barlegend,
        tooltip: {
          show: true,
          confine: true
        },
        grid: barGrid,
        xAxis: {
          show: true,
          type: 'category',
          data: option.xAxis.data,
          axisLabel: {
            interval: 0,
            rotate: barChartData[0].data.length > 20 ? 30 : barChartData[0].data.length > 10 ? 20 : 0
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          }
        },
        yAxis: [
          {
            show: true,
            type: 'value',
            splitLine: {
              //网格线
              lineStyle: {
                type: 'dotted',
                color: '#969797'
              },
              show: true //隐藏或显示
            }
          }
        ],
        series: barChartData
      }
      return bar
    case 'bar':
      let barData1 = JSON.parse(JSON.stringify(option));
      barData1.animation = animation !== undefined ? animation : true
      barData1.legend = {
        // type: 'scroll',
        show: true,
        bottom: 0,
        right: 'center',
        width: '100%',
        icon: 'rect',
        itemWidth: 14,
        itemHeight: 4,
        textStyle: {
          color: '#B4BAC6',
          fontSize: 12
        },
        formatter: val => {
          return val.length > 10 ? val.slice(0, 10) + '...' : val
        }
      }
      barData1.tooltip = {
        show: true
      }
      barData1.grid = {
        top: 20
      }
      Object.assign(barData1.grid, option.grid)
      barData1.xAxis.forEach(item => {
        item.splitLine = {
          show: false
        }
        item.axisTick = {
          show: false
        }
        item.axisLine = {
          lineStyle: {
            color: '#d8dee6'
          }
        }
        if (item.type === 'value') {
          item.splitLine = {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#d8dee6'
            }
          }
          item.axisLabel = {
            rotate: 15
          }
        }
        if(item.customerLized) {
          item.axisLabel = {
            show: true,
            formatter: (value, index)=>{
              if(localStorage.getItem("language")=='en') {
                return this.$util.formatterAxixEn(value)
              } else {
                return this.$util.formatterAxix(value)
              }
            },
            rotate: 15,
          }
        }
      })
      barData1.yAxis.forEach(item => {
        item.axisLine = {
          lineStyle: {
            color: '#d8dee6'
          }
        }
        item.axisTick = {
          show: false
        }
        if (item.type === 'value') {
          item.splitLine = {
            show: true,
            lineStyle: {
              type: 'solid',
              color: '#d8dee6'
            }
          }
        }
      })
      barData1.series.forEach(item => {
        item.barMaxWidth = 25
        item.barMinWidth = 10
        item.barCategoryGap = 20
      })
      return option.series.length > 0 ? barData1 : {}
    case 'map': //地图
      let allProvince = [
        '南海诸岛',
        '北京',
        '天津',
        '上海',
        '重庆',
        '河北',
        '河南',
        '云南',
        '辽宁',
        '黑龙江',
        '湖南',
        '安徽',
        '山东',
        '新疆',
        '江苏',
        '浙江',
        '江西',
        '湖北',
        '广西',
        '甘肃',
        '山西',
        '内蒙古',
        '陕西',
        '吉林',
        '福建',
        '贵州',
        '广东',
        '青海',
        '西藏',
        '四川',
        '宁夏',
        '海南',
        '台湾',
        '香港',
        '澳门'
      ]

      let chinaChartData = json
      let colors = ['rgba(253,193,45, 0.7)', 'rgba(254,126,35, 0.7)', 'rgba(252,92,44, 0.7)', 'rgba(48,201,242, 0.7)', 'rgba(37,177,228, 0.7)', 'rgba(32,151,209, 0.7)', 'rgba(181,210,60, 0.7)', 'rgba(141,197,74, 0.7)', 'rgba(104,174,75, 0.7)', '#8e8e8e']
      let splitList = []
      let sortBarData = sort('total', 'desc', json)
      let sortAscBarData = sort('total', 'asc', json)
      let unit = unitText[checkUnit(sortBarData[0].total === 0 || sortBarData[0].total < 100 ? sortBarData[1].total : sortBarData[0].total)]
      chinaChartData = json.map(item => {
        return {
          name: item.name,
          total: (item.total / checkUnit(sortBarData[0].total === 0 || sortBarData[0].total < 100 ? sortBarData[1].total : sortBarData[0].total)).toFixed(2)
        }
      })
      if (json) {
        chinaChartData = chinaChartData.map((d, index) => {
          if (d.name === sortAscBarData[0].name) {
            return {
              name: d.name
                .replace('省', '')
                .replace('市', '')
                .replace('回族自治区', '')
                .replace('维吾尔自治区', '')
                .replace('壮族自治区', '')
                .replace('自治区', ''),
              value: d.total,
              itemStyle: {
                areaColor: '#2491b4'
              }
            }
          } else if (d.name === sortAscBarData[1].name) {
            return {
              name: d.name
                .replace('省', '')
                .replace('市', '')
                .replace('回族自治区', '')
                .replace('维吾尔自治区', '')
                .replace('壮族自治区', '')
                .replace('自治区', ''),
              value: d.total,
              itemStyle: {
                areaColor: '#22b4d5'
              }
            }
          } else {
            return {
              name: d.name
                .replace('省', '')
                .replace('市', '')
                .replace('回族自治区', '')
                .replace('维吾尔自治区', '')
                .replace('壮族自治区', '')
                .replace('自治区', ''),
              value: d.total
            }
          }
        })
        let notContain = []
        allProvince.forEach(item => {
          if (!chinaChartData.find(c => c.name === item)) {
            notContain.push(item)
          }
        })
        notContain.forEach(nc => {
          chinaChartData.push({
            name: nc,
            value: 0,
            itemStyle: {
              areaColor: '#e2e7ea'
            }
          })
        })
        splitList = chinaChartData.map((c, index) => {
          return {
            label: c.name,
            start: c.value,
            end: c.value,
            color: colors[index % colors.length]
          }
        })
      }
      let chinamap = {
        dataRange: {
          x: '-1000 px', //图例横轴位置
          y: '-1000 px', //图例纵轴位置
          splitList: splitList
        },
        series: [
          {
            name: '中国',
            type: 'map',
            mapType: 'china',
            itemStyle: {
              areaColor: '#d1ecf7',
              borderColor: '#fff'
            },
            label: {
              normal: {
                show: true, //显示省份标签
                formatter: `{a|{b}}\n{a|{c}}{a|${unit}}`,
                rich: {
                  a: {
                    fontSize: 8
                  }
                }
              }
            },
            data: chinaChartData
          }
        ]
      }
      return chinamap
    case 'mapst'://中国
      // option.data.forEach(item => {
        // item.label = {
        //   normal: {
        //     show: true,
        //     formatter: function (params) {
        //       return params.name + "\n" + params.value;    //地图上展示文字 + 数值
        //     },
        //   }
        // };
      // });
      let optionChinaMap = {
        dataRange: {
          x: '-1000 px', //横轴位置
          y: '-1000 px', //纵轴位
          // text:['高','低'], // 文本，默认为数值文本
          calculable: true,
          color: ['#62B6FF']//值域颜色
        },
        title: {
          text:option.title?.text,
          textStyle: {
            fontSize: 13,
          },
          x: 'center',
          y: 'bottom',
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "horizontal", //图例的排列方向
          textStyle: { color: "#ccc" },
          x: '-1000 px', //图例横轴位置
          y: '-1000 px',

          // data: ["全国数据"]
        },

        visualMap: {
          // textStyle: { color: "#ccc" },
          x: "left",
          y: "bottom",
          splitList: [
          ],
          show: false,
        },
        grid: {
          top: 60,
          right: 70,
          bottom: 30,
          left: 60,
          containLabel: true,
        },
        // roamController: {//控制地图的上下左右放大缩小
        //     show: true,
        //     x: 'right',
        //     mapTypeControl: {
        //         'china': true
        //     }
        // },
        series: [
          {
            // name: "全国数据",
            type: "map",
            mapType: "china",
            zoom: 1.1,//地图大小
            roam: false, //是否开启鼠标缩放和平移漫游
            itemStyle: {
              //地图区域的多边形 图形样式
              normal: {
                //是图形在默认状态下的样式
                label: {
                  show: true,
                  // textStyle: { color: "#1A173B" }//地图text样式
                },
                areaColor: "#D1ECF7",
                //默认的地图板块颜色
                borderWidth: 1.5,
                borderColor: '#EDF5F7',
              },
              emphasis: {
                //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                label: { show: true },
                areaColor: 'rgb(213, 214, 79)'
              }
            },
            //组件距离容器的距离
            data: option.data
          }
        ]
      }
      return optionChinaMap
    case 'mapchina'://中国
      let optionChinaMapTrend = {
        tooltip: {
          show: true,
          trigger: 'item',
          formatter: params => {
            return params.data ? `${params.data.key}：${params.value}` : ``
          }
        },
        visualMap: {
          type: 'continuous',
          orient: 'horizontal',
          show: true,
          min: option.min < option.max ? option.min : 0,
          max: option.max,
          calculable: true,
          showLabel: true,
          inRange: {
            color: ['rgba(227, 240, 255, 1)', 'rgba(161, 205, 255, 1)', 'rgba(94, 169, 255, 1)', 'rgba(53, 147, 255, 1)', 'rgba(0, 119, 255, 1)']
          },
          textStyle: {
            color: '#7B93A7'
          },
          itemHeight: 200,
          itemWidth: 10,
          bottom: 5,
          left: 'center',
          right: 0
        },
        series: [
          {
            // name: "全国数据",
            type: "map",
            mapType: "china",
            // zoom: 1.1,//地图大小
            roam: false, //是否开启鼠标缩放和平移漫游
            itemStyle: {
              //地图区域的多边形 图形样式
              normal: {
                //是图形在默认状态下的样式
                label: {
                  show: true,
                  formatter: params => {
                    return params.data ? params.data.key : ``
                  }
                  // textStyle: { color: "#1A173B" }//地图text样式
                },
                //默认的地图板块颜色
                borderWidth: 1.5,
                borderColor: '#EDF5F7',
              },
              left: 0,
              top: 5,
              right: 0,
              bottom: 5,
              emphasis: {
                itemStyle: {
                  areaColor: 'rgba(252, 200, 0, 1)'
                },
                label: {
                  show: true,
                  formatter: params => {
                    return params.data ? params.data.key : ``
                  }
                }
              },
            },
            //组件距离容器的距离
            data: option.data
          }
        ]
      }
      return optionChinaMapTrend
    case 'bar_line': //柱线图
      let lineData = option.series.filter(item => item.type === 'line')
      let barData = option.series.filter(item => item.type === 'bar')
      let finalLineBarSeries = []
      let blData = []
      barData.forEach(item => {
        blData = blData.concat(item.data)
      })
      let sortBarLineData = sort('', 'desc', blData)
      let BarLineUnit = unitText[checkUnit(sortBarLineData[0] === 0 || sortBarLineData[0] < 100 ? sortBarLineData[1] : sortBarLineData[0])]
      barData.forEach(item => {
        let data = item.data.map(d => {
          return Number((d / checkUnit(sortBarLineData[0] === 0 || sortBarLineData[0] < 100 ? sortBarLineData[1] : sortBarLineData[0])).toFixed(2))
        })
        item.yAxisIndex = 0
        item.legend = {
          icon: 'circle'
        }
        item.label = {
          show: true,
          position: 'top',
          color: '#000',
          formatter: `{c}${BarLineUnit}`
        }
        item.barMaxWidth = 50
        item.data = data
        finalLineBarSeries.push(item)
      })
      lineData.forEach(item => {
        item.yAxisIndex = 1
        item.label = {
          show: true,
          position: 'top',
          color: '#000'
        }
        finalLineBarSeries.push(item)
      })
      if (option.yAxis instanceof Array) {
        option.yAxis[0].splitLine = {
          //网格线
          lineStyle: {
            type: 'dotted',
            color: '#969797'
          },
          show: true //隐藏或显示
        }
        option.yAxis[1] = {
          type: 'value',
          splitLine: {
            show: false
          }
        }
      } else {
        option.yAxis.splitLine = {
          //网格线
          lineStyle: {
            type: 'dotted',
            color: '#969797'
          },
          show: true //隐藏或显示
        }
      }
      if (option.xAxis instanceof Array) {
        option.xAxis.forEach(item => {
          item.splitLine = {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          }
        })
      } else {
        option.xAxis.splitLine = {
          //网格线
          lineStyle: {
            type: 'dotted',
            color: '#969797'
          },
          show: true //隐藏或显示
        }
      }

      let lineBar = {
        legend: {
          show: true,
          right: 10,
          orient: 'vertical'
        },
        grid: {
          right: 150
        },
        xAxis: Object.assign(option.xAxis, {
          splitLine: {
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true
          }
        }),
        yAxis: option.yAxis,
        series: finalLineBarSeries
      }
      return lineBar
    case 'bar-to'://纵向柱状图
      let bartoData = option.series
      let lineBarzx = {
        xAxis: [
          {
            type: option.xAxis[0].type,
            data: option.xAxis[0].data,
            axisLabel: {
              interval: 0,
              rotate: 20,
            },
          },


        ],
        grid: {
          containLabel: true,
        },
        yAxis: [{
          type: "value",
        }],
        // yAxis: option.yAxis,
        // color:['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'],
        series: [
          {
            data: option.series[0].data,
            type: option.series[0].type,
            // color:this.color,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList =['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'];
                  return colorList[params.dataIndex % colorList.length]
                },
                label: {
                  show: true,
                  position: 'top',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  }
                }
              }
            },
          }
        ],
      }
      return lineBarzx
    case 'piejc'://饼图图表
      // let fakeData1 = option.series
      let fakedata = {
        // title: {
        //   text:option.title.text,
        //   left: 'left'
        // },
        title: {
          text: option.title.text,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 13,
          },
          //   textStyle: {
          //     fontFamily: 'Arial, Verdana, sans...',
          //     fontSize: 15,
          //     fontStyle: 'normal',
          //     fontWeight: 'normal',
          // },
        },

        tooltip: {
          trigger: 'item'
        },
        legend: {
          icon: "circle",
          left: 'right',
          // align:'right',
          orient: 'right',
        },
        color:['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'],
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '70%',
            minAngle:20,
            avoidLabelOverlap:true,
            data: option.series,
            color: this.color,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                show: true,
                position: 'outer',
                textStyle: {
                  fontSize: 12
                },
                formatter: function (p) {
                  return p.data.name;
                }
              }
            },
          },
          {
            // name: 'Access From',
            type: 'pie',
            radius: '70%',
            minAngle:20,
            avoidLabelOverlap:true,
            data: option.series,
            color: this.color,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                show: true,
                position: 'inner',
                textStyle: {
                  fontSize: 12
                },
                formatter: '{d}%'
              }
            },
          },
        ]
      }
      return fakedata
    case 'categchne'://图表
      // let fakeData1 = option.series
      let categchne = {
        title: {
          text: option.title.text,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 13,
          },
        },
        grid: {
          bottom: 40,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: option.xAxis.data,
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 4;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }
        },
        yAxis: option.yAxis,
        series: [
          {
            data: option.series.data,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList =['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'];
                  return colorList[params.dataIndex % colorList.length]
                },
                label: {
                  show: true,
                  position: 'top',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  },
                  formatter: function (params) {
                    let value = params.value;  // 获取当前数据点的值
                    if (value >= 1e9) {
                      return (value / 1e9).toFixed(1) + 'B'; // 十亿
                    } else if (value >= 1e6) {
                      return (value / 1e6).toFixed(1) + 'M'; // 百万
                    } else if (value >= 1e3) {
                      return (value / 1e3).toFixed(1) + 'K'; // 千
                    } else {
                      return value; // 小于千的数值直接显示
                    }
                  }
                }
              }
            },
            type: 'bar'
          }

        ],
      }
      return categchne
      case 'categchnete':
      // let fakeData1 = option.series
      let categchnete = {
        title: {
          text: option.title.text,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 13,
          },
        },
        grid: {
          bottom: 40,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: option.xAxis.data,
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 4;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }
        },
        yAxis:option.yAxis,
        series: [
          {
            data: option.series.data,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList =['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'];
                  return colorList[params.dataIndex % colorList.length]
                },
                label: {
                  show: true,
                  position: 'top',
                  formatter: '{c}%',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  },
                }
              }
            },
            type: 'bar'
          },
          // {
          //   data: option.series.data,
          //   yAxisIndex: 1,
          //   type: 'line',
          // },
        ],
      }
      return categchnete
    case 'DoughnutChar'://环形图表
      // let fakeData1 = option.series
      let DoughnutChar = {
        title: {
          text: option.title.text,
          textStyle: {
            fontSize: 13,
          },
          x: 'center',
          y: 'bottom',
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          icon: "circle",
          left: 'right',
          orient: 'right',
        },

        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },

            label: {
              normal: {
                show: true,
                position: 'inner',
                formatter: '{d}%',
                textStyle: {
                  fontSize: 12
                },
              }
            },
            data: option.series,
          },
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              normal: {
                length: 18,
                length2: 10,
              }
            },
            label: {
              normal: {
                formatter: '{b}',
                padding: [0, 0],
                rich: {
                  a: {
                    color: '#999',
                    lineHeight: 20,
                    align: 'center'
                  },
                  hr: {
                    borderColor: 'auto',
                    width: '105%',
                    borderWidth: 0.5,
                    height: 0.5,
                  },
                  per: {
                    padding: [4, 0],
                  }
                }
              }
            },
            data: option.series,
          },
        ]
      }
      return DoughnutChar
    case 'ColumnFolding':
      let uvMaxt =  this.$url._calcMaxNumber(option.series[0].data);
      let uvMint =  this.$url._calcMinNumber(option.series[0].data);
      let cliMaxt= this.$url._calcMaxNumber(option.series[1].data);
      let cliMint = this.$url._calcMinNumber(option.series[1].data);
      let ColumnFolding = {
        title: {
          text: option.title.text,
          x: 'center',
          y: 'bottom',
          textStyle: {
            fontSize: 13,
          },
        },
        grid: {
          bottom: 40,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: option.xAxis.data,
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 4;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }
        },
        yAxis:[
         { 
            type: "value",
            min:uvMint,
            max:uvMaxt,
            splitNumber:5,
            interval:(uvMaxt-uvMint)/5,
          },
         {
           type: "value",
           min:cliMint,
           max:cliMaxt,
           splitNumber:5,
           interval:(cliMaxt-cliMint)/5,
          },
        ],
        series: [
          {
            data: option.series[0].data,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList =['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'];
                  return colorList[params.dataIndex % colorList.length]
                },
                label: {
                  show: true,
                  position: 'insideBottom',
                  textStyle: {
                    color: 'black',
                    fontsize: 14,
                  },
                }
              }
            },
            type: 'bar'
          },
          {
            data:option.series[1].data,
            yAxisIndex:1,
            type: 'line',
            itemStyle : { 
              normal: {
                color:'#4689E8',
               label : {show: true, formatter: '{c}%',},
              }
            },
          },
        ],
      }
      return ColumnFolding
    case 'analysis':
      let uvMax =  this.$url.calcMaxNumber(option.series[0].data);
      let uvMin =  this.$url.calcMinNumber(option.series[0].data);
      let cliMax= this.$url.calcMaxNumber(option.series[1].data);
      let cliMin = -10;
      let analysis = {
        // title: {
        //   text: option.title.text,
        //   x: 'center',
        //   y: 'bottom',
        //   textStyle: {
        //     fontSize: 13,
        //   },
        // },
        grid: {
          bottom: 40,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: option.xAxis.data,
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 4;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }
        },
        yAxis:[
         {
           type: "value",
            // min:uvMin,
            max:formatRoundNum(uvMax),
            // splitNumber:5,
            // interval:(uvMax-uvMin)/5,
        },
         {
           type: "value",
           min:cliMin,
           max:(cliMax+5),
          //  splitNumber:5,
          //  interval:(cliMax-cliMin)/5,
          splitLine: {
            show: false
          },
           axisLabel: {
            formatter: '{value} %'
          }
          },
        ],
        series: [
          {
            data: option.series[0].data,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorList =['#EA5519','#F6AF0F','#FCC800','#799DCE','#8080D8','#A389E0','#D186B5','#68AE4B','#8DC54A','#B5D23D','#DEDEDE'];
                  return colorList[params.dataIndex % colorList.length]
                },
                label: {
                  show: true,
                  position: 'top',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  },
                }
              }
            },
            type: 'bar'
          },
          {
            data:option.series[1].data,
            yAxisIndex:1,
            type: 'line',
            itemStyle : { 
              normal: {
                color:'#4689E8',
               label : {show: true, formatter: '{c}%',},
              }
            },
          },
        ],
      }
      return analysis
    
    case 'bardouble'://双柱图
      let bardouble = {
        title: {
          text: option.title.text,
          textStyle: {
            fontSize: 13,
          },
          x: 'center',
          y: 'bottom',
        },
        grid: {
          top: 60,
          right: 70,
          bottom: 30,
          left: 60,
          containLabel: true,
        },
        legend: {
          icon: "circle",
          top: 32,
          left: 'center',
          data: option.legend.data,

        },
        calculable: true,
        xAxis: {
          type: option.xAxis.type,
          data: option.xAxis.data,
          axisLine: {
            show: false
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          axisLabel: {
            formatter: function (params) {
              var newParamsName = "";
              var paramsNameNumber = params.length;// 实际标签的个数
              var provideNumber = 2;// 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber);// 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = "";// 表示每一次截取的字符串
                  var start = p * provideNumber;// 开始截取的位置
                  var end = start + provideNumber;// 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr;// 最终拼成的字符串
                }

              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName
            }

          }


        },
        yAxis: [
          {
            // type: "value",
            type: 'log',
            // name: "单位（百万）",
            // axisLabel: {
            //   //这种做法就是在y轴的数据的值旁边拼接单位，貌似也挺方便的
            //   formatter: "{value} 百万",
            // },
          },
          {
            type: "log",
          }
        ],
        series: [
          {
            name: option.series[0].name,
            type: option.series[0].type,
            yAxisIndex: 0,
            data: option.series[0].data,
            itemStyle: {
              normal: {
                color: '#EA5519',
                label: {
                  show: true,
                  position: 'top',
                  rotate: 90,
                  distance: 25,
                  offset: [0, 5],
                  textStyle: {
                    color: '#EA5519',
                    fontSize: 12,
                  },
                  formatter: function (params) {
                    let value = params.value;  // 获取当前数据点的值
                    if (value >= 1e9) {
                      return (value / 1e9).toFixed(1) + 'B'; // 十亿
                    } else if (value >= 1e6) {
                      return (value / 1e6).toFixed(1) + 'M'; // 百万
                    } else if (value >= 1e3) {
                      return (value / 1e3).toFixed(1) + 'K'; // 千
                    } else {
                      return value; // 小于千的数值直接显示
                    }
                  }
                }
              }
            }
          },
          {
            name: option.series[1].name,
            type: option.series[1].type,
            yAxisIndex: 0,
            data: option.series[1].data,
            barGap:0,
            itemStyle: {
              normal: {
                color: '#799DCE',
                label: {
                  show: true,
                  position: 'top',
                  rotate: 90,
                  distance: 25,
                  offset: [0, 5],
                  textStyle: {
                    color: '#799DCE',
                    fontSize: 12,
                  },
                  formatter: function (params) {
                    let value = params.value;  // 获取当前数据点的值
                    if (value >= 1e9) {
                      return (value / 1e9).toFixed(1) + 'B'; // 十亿
                    } else if (value >= 1e6) {
                      return (value / 1e6).toFixed(1) + 'M'; // 百万
                    } else if (value >= 1e3) {
                      return (value / 1e3).toFixed(1) + 'K'; // 千
                    } else {
                      return value; // 小于千的数值直接显示
                    }
                  }
                }
              }
            }
          },
        ]
      }
      return bardouble
    case 'PositiveNegative'://正负柱图

      let bardoubl1 = {
        title: {
          text: option.title.text,
          textStyle: {
            fontSize: 13,
          },
          x: 'center',
          y: 'bottom',
        },
        grid: {
          top: 60,
          right: 70,
          bottom: 30,
          left: 60,
          containLabel: true,
        },
        legend: {
          icon: "circle",
          top: 32,
          left: 'center',
          // data:option.legend.data,

        },
        calculable: true,
        xAxis: {
          xAxis: [
            {
              type: 'value',
              nameRotate: 45,
            }
          ],
        },
        yAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: option.xAxis.data,
          }
        ],
        series: [
          {
            name: option.series[0].name,
            type: option.series[0].type,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: '#EA5519',
                label: {
                  show: true,
                  position: 'top',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  }
                }
              }
            },
            data: option.series[0].data.map((item) => {
              return {
                value: item,
                label: {
                  show: true,
                  formatter: '{c}%',
                  position: item > 0 ? 'right' : 'left',
                  textStyle: {
                    color: '#ccc',
                    fontSize: 12
                  },
                }

              }
            }),


          },
          {
            name: option.series[1].name,
            type: option.series[1].type,
            barWidth: 30,
            itemStyle: {
              normal: {
                color: '#799DCE',
                label: {
                  show: true,
                  position: 'top',
                  textstyle: {
                    color: 'black',
                    fontsize: 14,
                  }
                }
              }
            },
            data: option.series[1].data.map((item) => {
  
              return {
                value: item,
                label: {
                  show: true,
                  formatter: '{c}%',
                  position: item > 0 ? 'right' : 'left',
                  textStyle: {
                    color: '#ccc',
                    fontSize: 12
                  },
                }

              }
            }),
          },
        ]
      }
      return bardoubl1
    case 'single-bar':
      let singleBar = {
        color: ['#86BDFF'],
        tooltip: {
          show: true
        },
        xAxis: [{
          type: 'category',
          data: option.map(el=>el.translatedName)
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
          "type": "bar",
          "data": option.map(el=>el.value),
          itemStyle: {
            normal: {
              label: {
                show: true, //开启显示
                position: 'top', //在上方显示
                textStyle: { //数值样式
                  color: '#86BDFF',
                  fontSize: 12
                },
                textBorderColor: "#fff",
                textBorderWidth: 1,
                formatter: function (params) {
                  let value = params.value;  // 获取当前数据点的值
                  if (value >= 1e9) {
                    return (value / 1e9).toFixed(1) + 'B'; // 十亿
                  } else if (value >= 1e6) {
                    return (value / 1e6).toFixed(1) + 'M'; // 百万
                  } else if (value >= 1e3) {
                    return (value / 1e3).toFixed(1) + 'K'; // 千
                  } else {
                    return value; // 小于千的数值直接显示
                  }
                }
              }
            }
          },
          markLine:{ // 设置平均线
            symbol: ['none', 'none'],
            label: {
              position: "end",
              formatter: function (params) {
                let value = params.value;  // 获取当前数据点的值
                if (value >= 1e9) {
                  return (value / 1e9).toFixed(1) + 'B'; // 十亿
                } else if (value >= 1e6) {
                  return (value / 1e6).toFixed(1) + 'M'; // 百万
                } else if (value >= 1e3) {
                  return (value / 1e3).toFixed(1) + 'K'; // 千
                } else {
                  return value; // 小于千的数值直接显示
                }
              }
            },
            data:[
              {
                type:"average", 
                name:"average",
                color:"#637280"
              }
            ]
          },
        }]
      };
      return singleBar
    case 'single-line':
      let singleLine = {
        animation: true,
        tooltip: {
          show: true
        },
        toolbox: {
          show: true
        },
        xAxis: [{
          show: true,
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#D8DEE6'
            }
          },
          axisLabel: {
            interval: "auto",
            color: '#637280',
          },
          data: option.map(el=>el.translatedName)
        }],
        yAxis: [{
          show: false,
          type: 'value',
          axisLine: {
            show: false
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'solid',
              color: '#D8DEE6'
            },
            show: true //隐藏或显示
          },
          axisTick: {
            show: false
          }
        }],
        series: [{
          type: "line",
          symbol: "triangle",
          smooth: false,
          symbolSize: 10,
          symbolRotate: (value, params)=>{
            if(value<=0) {
              return 180
            } 
          },
          lineStyle: {
            color: "#5B98E1"
          },
          itemStyle: {
            // 设置symbol的颜色
            normal: {
              color: (params)=>{
                if(params.data>0) {
                  return "#E76262"
                } else {
                  return "#26AC72"
                }
              }
            }
          },
          label: {
            show: true,
            color: "#3D3A7D",
            formatter: params => {
              return params.data ? params.data+"%" : ''
            }
          },
          data: option.map(el=>el.ratio),
        }]
      };
      return singleLine
    case 'single-pie':
      let singlePie = {
        animation: true,
        color: ['#5B98E1', '#FF7138', '#70C8A2', '#75B4FF', '#FF995A', '#9ED2BC', '#B0D4FF', '#FFBC93', '#CBF3E2', '#D3D5D8', '#E76262'],
        tooltip: {
          formatter: '{b} : {c} ({d}%)'
        },
        minAngle: 15,
        series: [{
          type: "pie",
          selectedMode: "multiple",
          bottom: 20,
          top: 10,
          itemStyle: {
            borderColor: '#ffffff',
            borderWidth: 1
          },
          // minShowLabelAngle: 1,
          label: {
            // show: true,
            // formatter: '{b} \r\n{d}%',
            formatter:function (params) {
              if(params.value=='0.00'||params.value=='0'){  //为0时不显示
                params.data.labelLine.show=false;
                params.data.label.show=false;
                return ''
              }else{
                return params.name + ' : ' + params.percent + '%'
              }
            }
          },
          data: option,
        }]
      };
      return singlePie
    case 'single-scatter':
      let singleScatter = {
        grid: {
          left: '3%',
          right: '7%',
          bottom: '7%',
          containLabel: true
        },
        tooltip: {
          showDelay: 0,
          formatter: (params)=> {
            if(params.componentType==='series') {
              let amount1 = params.data[5]
              let count1 = params.data[6]
              return `${params.data[3]}<br/>${this.$i18.language('交易总额')}：${amount1};${this.$i18.language('交易次数')}：${count1};${this.$i18.language('最近交易时间')}：${params.data[2]}`
            }
          },
        },
        emphasis: {
          itemStyle: {
            color: '#EA5519'
          },
        },
        xAxis: [{
          type: 'log',
          logBase:10,
          name: this.$i18.language('交易金额'),
          nameLocation: "middle",
          nameTextStyle: {
            padding: 10
          },
        }],
        yAxis: [{
          type: 'log',
          logBase:10,
          nameLocation: "middle",
          nameTextStyle: {
            padding: 10
          },
          axisLabel: {
            formatter: function (value) {
              return value === 0.01 ? 0 : value;
            }
          },
        }],
        series: option
      };
      return singleScatter
    case 'bar-to1'://纵向柱状图
      let bartoData1 = option.series
      let lineBarzxt = {
        xAxis: option.xAxis,
        yAxis: [{
          type: "category"
        }],
        series: [
          {
            data: option.series[0].data,
            type: option.series[0].type,
            barWidth: 40,
            itemStyle: {
              normal: {
                color: function () {
                  return '#5882FA'
                },
              },
            },
          }
        ],
      }
      return lineBarzxt
    case 'shadow'://叠条形图
      let shadowdate = {
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          },
          axisPointer: {
            type: 'shadow'
          },
        },
        legend: {
          bottom: 0,
          right: 'center',
          width: '100%',
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 4,
          textStyle: {
            color: '#1A173B',
            // color: '#B4BAC6',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          // bottom: '8%',
          containLabel: true
        },
        xAxis: option.xAxis,
        yAxis: option.yAxis,
        series: option.series,
      }
      return shadowdate
      case 'shadow1'://叠条形图
      let shadowdate1 = {
        tooltip: {
          trigger: 'axis',
          position: function (point, params, dom, rect, size) {
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置
            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];
            if (boxWidth > pointX) {
              x = 5;
            } else {
              x = pointX - boxWidth;
            }
            // boxHeight>pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else { // 上边放得下
              y = pointY - boxHeight;
            }
            return [x, y];
          },
          axisPointer: {
            type: 'shadow'
          },
        },
        legend: {
          bottom: -5,
          right: 'center',
          width: '100%',
          icon: 'rect',
          type:'scroll',
          pageButtonPosition:'end',
          pageIconColor:'#3ba1ff',
          itemWidth: 8,
          itemHeight: 4,
          textStyle: {
            color: '#1A173B',
            fontSize: 12
          },
          formatter: val => {
            return val.length > 10 ? val.slice(0, 10) + '...' : val
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          // bottom: '8%',
          containLabel: true
        },
        xAxis: option.xAxis,
        yAxis:  [
          {
            type: 'value'
          },
          {
            type: 'value',
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: option.series.map((item, index)=>{
          if(item.type == 'line') {
            item.yAxisIndex = 1
            delete item.stack
          }
          return item
          })
        // color: ['#EA5519', '#799DCE','#F6AB00'] // 三个折线的颜色
      }
      return shadowdate1
    case 'bar-x': //横的柱状图
      let barRowData = option.series
      let allBarRowData = []
      barRowData.forEach(item => {
        allBarRowData = allBarRowData.concat(item.data)
      })
      let sortBarRowData = sort(
        '',
        'desc',
        allBarRowData.filter(item => item !== 0 || item > 100)
      )
      let barRowUnit = unitText[checkUnit(sortBarRowData[0])]
      barRowData.forEach(item => {
        item.barMaxWidth = 18
        item.stack = '数量'
        item.label = {
          show: true,
          color: colorType === 'black' ? '#fff' : '#000',
          formatter: function (params) {
            let axisData = option.xAxis.data && option.xAxis.data !== null ? option.xAxis.data : option.yAxis.data ? option.yAxis.data : option.yAxis[0].data
            return show === 'label' ? axisData[params.dataIndex] : Math.abs(params.value) + barRowUnit
          },
          position: 'insideLeft'
        }

        if (item.data.length <= 10) {
          item.itemStyle = {
            normal: {
              color: function (params) {
                var colorList = ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e']
                return colorList[params.dataIndex % colorList.length]
              }
            }
          }
        }
      })
      let barRow = {
        legend: {
          show: false
        },
        tooltip: {
          show: true,
          confine: true
        },
        grid: {
          top: 20,
          left: 20,
          right: 30
        },
        xAxis: {
          type: 'value',
          axisLine: {
            show: false
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          }
        },
        yAxis: {
          type: 'category',
          position: 'left',
          inverse: true,
          axisLabel: {
            show: false
          },
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          data: option.xAxis.data && option.xAxis.data !== null ? option.xAxis.data : option.yAxis.data ? option.yAxis.data : option.yAxis[0].data
        },
        series: barRowData
      }
      return barRow
    case 'bar-negative':
      let barNegativeData = option.series
      let allData = []
      barNegativeData.forEach(item => {
        allData = allData.concat(item.data)
      })
      let sortBarNegativeData = sort(
        '',
        'desc',
        allData.filter(item => item !== 0 || item > 100)
      )
      let barNegativeUnit = unitText[checkUnit(sortBarNegativeData[0])]
      barNegativeData.forEach((item, index) => {
        let returnData = item.data.map(d => {
          return (d / checkUnit(checkUnit(sortBarNegativeData[0]))).toFixed(2)
        })
        item.data = returnData
        if (index === 0) {
          item.data = item.data.map(d => {
            return -d
          })
          item.label = {
            show: true,
            color: '#000',
            formatter: function (params) {
              return Math.abs(params.value) + barNegativeUnit
            },
            position: 'left'
          }
        } else {
          item.label = {
            show: true,
            color: '#000',
            formatter: function (params) {
              return Math.abs(params.value) + barNegativeUnit
            },
            position: 'right'
          }
        }
        item.barMaxWidth = 18
        item.stack = '金额'
      })
      let barNegative = {
        legend: {
          show: true,
          orient: 'vertical',
          right: 5,
          top: 20,
          icon: 'circle'
        },
        grid: {
          top: 20,
          left: 80,
          right: 150
        },
        xAxis: {
          type: 'value',
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          axisLabel: {
            show: true,
            formatter: function (value) {
              return Math.abs(value)
            }
          }
        },
        yAxis: {
          type: 'category',
          position: 'left',
          splitLine: {
            //网格线
            lineStyle: {
              type: 'dotted',
              color: '#969797'
            },
            show: true //隐藏或显示
          },
          data: option.xAxis.data && option.xAxis.data !== null ? option.xAxis.data : option.yAxis[0].data
        },
        series: barNegativeData
      }
      return barNegative
    // case "treemap"://
    //   option.series.forEach(item => {
    //     item.breadcrumb = {
    //       show: false
    //     };
    //     item.width = "90%";
    //     item.height = "90%";
    //     item.roam = false;
    //     item.nodeClick = false;
    //     item.label = {
    //       show: true,
    //       ellipsis: false,
    //       formatter: function(params) {
    //         return `${params.name}\n${params.value}%`;
    //       }
    //     };
    //   });
    //   let treemap = {
    //     grid: {
    //       bottom: 30
    //     },
    //     series: option.series
    //   };
    //   return treemap;

    case 'simpleLine':
      let simpleLineData = option.series[0].data
      // let simpleLineXAxisLable = option.map(item => {
      //   return item.date
      // // })
      let descSimpleLineData = sort('', 'desc', simpleLineData)
      let ascSimpleLineData = sort('', 'asc', simpleLineData)
      let simpleLine = {
        animation: animation !== undefined ? animation : true,
        xAxis: {
          show: false,
          type: 'category'
          // data: simpleLineXAxisLable
        },
        yAxis: {
          show: false,
          type: 'value'
          // min: descSimpleLineData[0] - 50,
          // max: ascSimpleLineData[0] + 50
        },
        grid: {
          top: 20,
          bottom: 20
        },
        series: [
          {
            type: 'line',
            data: option.series[0].data,
            areaStyle: {
              color: 'rgba(255, 199, 46, 0.2)'
            },
            lineStyle: {
              width: 1.5
            },
            itemStyle: {
              color: 'rgba(255, 199, 46, 1)',
              opacity: 0
            }
          }
        ]
      }
      return simpleLine
    case 'double_pie':
      let doublePieData = option.series
      let innerPie = doublePieData.find(item => item.targetName)
      let outerPie = doublePieData.find(item => !item.targetName)
      innerPie = {
        type: 'pie',
        radius: [0, '30%'],
        label: {
          normal: {
            show: true,
            color: store.getters.themeType === 'dark' ? '#fff' : '#000',
            formatter: `{d}%`,
            position: 'inside'
          }
        },
        data: innerPie.data
      }
      outerPie = {
        type: 'pie',
        radius: ['50%', '70%'],
        label: {
          normal: {
            show: true,
            color: store.getters.themeType === 'dark' ? '#fff' : '#000',
            formatter: `{d}%`,
            position: 'inside'
          }
        },
        data: outerPie.data
      }
      let doublePie = {
        animation: animation !== undefined ? animation : true,
        legend: {
          show: true,
          icon: 'circle'
        },
        tooltip: {
          show: true
        },
        color: ['#fdc12d', '#fe7e23', '#fc5c2c', '#30c9f2', '#25b1e4', '#2097d1', '#b5d23c', '#8dc54a', '#68ae4b', '#8e8e8e'],
        series: [innerPie, outerPie]
      }
      return doublePie
    default:
      break
  }
}
